<app-navbar />

<div class="container-fluid">
  <!-- Filtros -->
  <div class="card shadow-sm filtros-modernas border-0 mb-4">
    <div class="card-header d-flex align-items-center rounded-top">
      <i class="fas fa-search fs-5 me-2 text-white"></i>
      <h2 class="fw-bold">Vistorias Concluídas</h2>
    </div>
    <div class="card-body">

      <!-- Linha com botão de filtro à esquerda e controles de paginação/itens por página à direita -->
      <div class="row mt-3" *ngIf="!erro">
        <div class="top-controls compact-controls d-flex flex-wrap align-items-center justify-content-between">
          <!-- Botões Filtrar e Exportar Excel -->
          <div class="d-flex gap-2">
            <button class="btn btn-info btn-sm" type="button" (click)="toggleFiltros()">
              <i class="fas fa-filter me-1"></i> Filtrar
            </button>
          </div>


          <!-- Período + Botão Recarregar -->
          <div class="d-flex align-items-center gap-2 me-3">
            <input class="form-control form-control-sm period-input" type="date" [(ngModel)]="filtroDataInicio" />
            <span>até</span>
            <input class="form-control form-control-sm period-input" type="date" [(ngModel)]="filtroDataFim" (change)="onFiltroDataFimChange()" />
            <button class="btn btn-primary ms-2" (click)="aplicarFiltro()">
              <i class="fas fa-sync-alt me-1"></i> Recarregar
            </button>
          </div>

          <!-- Itens por página + Paginação -->
          <div class="d-flex align-items-center gap-2 ms-auto">
            <label class="mb-0 small">Itens:</label>
            <select id="tamanhoPaginaSelect" class="form-select form-select-sm" [(ngModel)]="tamanhoPagina"
              (ngModelChange)="alterarTamanhoPagina($event)">
              <option [value]="5">5</option>
              <option [value]="10">10</option>
              <option [value]="25">25</option>
              <option [value]="50">50</option>
              <option [value]="100">100</option>
            </select>

            <span class="page-info small">
              Página {{paginaAtual}} de {{totalPaginas}} ({{totalItens}} itens)
            </span>

            <!-- Botões -->
            <button class="btn btn-outline-secondary btn-sm" (click)="paginaAnterior()" [disabled]="paginaAtual <= 1">
              <i class="fas fa-chevron-left"></i>
            </button>
            <button class="btn btn-outline-secondary btn-sm" (click)="proximaPagina()"
              [disabled]="paginaAtual >= totalPaginas">
              <i class="fas fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="row mt-2" *ngIf="showFiltros">
        <!-- <div class="col-md-3">
          <label class="form-label">Status</label>
          <select class="form-select" [(ngModel)]="filtroStatus">
            <option value="">Todos</option>
            <option value="EmAndamento">EmAndamento</option>
            <option value="Concluida">Concluido</option>
            <option value="Retornar">Retornar</option>
            <option value="Negada">Negado</option>
            <option value="Validado">Validado</option>
            <option value="Invalido">Invalido</option>
          </select>
        </div> -->
        <!-- <div class="col-md-3">
          <label class="form-label">Matrícula</label>
          <input type="text" class="form-control" [(ngModel)]="filtroMatricula" placeholder="Matrícula do consumidor" />
        </div> -->
        <div class="col-md-3">
          <label class="form-label">Nº Vistoria</label>
          <input type="text" class="form-control" [(ngModel)]="filtroNumeroVistoria" placeholder="Nº Vistoria" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Nome Consumidor</label>
          <input type="text" class="form-control" [(ngModel)]="filtroNomeConsumidor" placeholder="Nome do consumidor" />
        </div>
        <div class="col-md-3">
          <label class="form-label">CPF</label>
          <input type="text" class="form-control" [(ngModel)]="filtroCpf" placeholder="CPF" />
        </div>
        <div class="col-md-3">
          <label class="form-label">CNPJ</label>
          <input type="text" class="form-control" [(ngModel)]="filtroCnpj" placeholder="CNPJ" />
        </div>
        <div class="col-md-3">
          <label class="form-label">CEP</label>
          <input type="text" class="form-control" [(ngModel)]="filtroCep" placeholder="CEP" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Número</label>
          <input type="text" class="form-control" [(ngModel)]="filtroNumero" placeholder="Número (logradouro)" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Logradouro</label>
          <input type="text" class="form-control" [(ngModel)]="filtroLogradouro" placeholder="Logradouro" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Bairro</label>
          <input type="text" class="form-control" [(ngModel)]="filtroBairro" placeholder="Bairro" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Cidade</label>
          <input type="text" class="form-control" [(ngModel)]="filtroCidade" placeholder="Cidade" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Estado</label>
          <input type="text" class="form-control" [(ngModel)]="filtroEstado" placeholder="Estado" />
        </div>
        <div class="col-12 mt-2 d-flex gap-2">
          <button class="btn btn-primary" (click)="aplicarFiltro()">Aplicar filtros</button>
          <button class="btn btn-secondary" (click)="resetarERecarregar()">Limpar e Recarregar</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Estados -->
  <div *ngIf="erro" class="alert alert-danger d-flex align-items-center gap-2">
    <i class="bi bi-exclamation-triangle-fill"></i> {{ erro }}
  </div>

  <div *ngIf="servicosFiltrados.length === 0 && (filtroUsuarioId || (!filtroUsuarioId && servicos.length === 0))"
    class="alert alert-warning d-flex align-items-center gap-2">
    <i class="bi bi-folder-x"></i> Nenhuma vistoria pendente encontrada {{ filtroUsuarioId ? 'no período' : '' }}.
  </div>

  <!-- Tabela de Vistoria -->
  <div class="table-responsive" *ngIf="servicosFiltrados.length > 0">
    <table class="table table-bordered table-hover align-middle">
      <thead class="table-light">
        <tr>
          <th>Data</th>
          <th>N° Vistoria</th>
          <th>Consumidor</th>
          <th>CPF/CNPJ</th>
          <th>Tipo Vistoria</th>
          <th>Status</th>
          <th>Endereço</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let servico of servicosFiltrados; let i = index; trackBy: trackById"
          [class]="i % 2 === 0 ? 'linha-par' : 'linha-impar'">
          <td>
            <span class="text-primary fw-bold">
              <i class="bi bi-calendar-date me-1"></i>
              {{ servico.dataServico | date:'dd/MM/yyyy' }}
            </span>
          </td>
          <td>
              <span class="n-vistoria" title="{{ formatNumeroOS(servico) }}">{{ formatNumeroOS(servico) }}</span>
            </td>
          <td>
            <span class="fw-bold text-dark">
              {{ servico.nomeConsumidor || servico.nome || 'Não informado' }}
            </span>
          </td>
          <td style="min-width: 180px;">
            <span>{{ getCpfCnpjDisplay(servico) }}</span>
          </td>
          <td>
            <span class="badge"
              [class]="getTipoServico(servico) === 'cadastro' ? 'cadastro-badge' : 'recadastro-badge'">
              {{ getTipoServico(servico) === 'cadastro' ? 'Cadastro' : 'Recadastro' }}
            </span>
          </td>
          <td>
            <span class="badge badge-concluida">
              <i class="bi bi-check-circle-fill me-1"></i>
              {{ getStatusOsDisplay(servico) }}
            </span>
          </td>
          <td>
            <span class="text-muted">{{ getEnderecoCompleto(servico) }}</span>
          </td>
          <td>
            <div class="action-buttons">
              <button *ngIf="canSeeAnalyzeButton" class="btn btn-sm btn-outline-primary" (click)="verDetalhes(servico)">Analisar</button>
              <button class="btn btn-sm btn-outline-info" (click)="onVer(servico)" 
                      [disabled]="viewLoading[servico.cadastroId || servico.recadastroId]">
                <span *ngIf="viewLoading[servico.cadastroId || servico.recadastroId]" 
                      class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                Ver
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Controles de Paginação -->
  <div class="d-flex justify-content-between align-items-center mt-3" *ngIf="totalPaginas > 1">
    <div class="d-flex align-items-center gap-3">
      <div class="text-muted">
        <small>
          Mostrando {{((paginaAtual - 1) * tamanhoPagina) + 1}} -
          {{Math.min(paginaAtual * tamanhoPagina, totalItens)}} de {{totalItens}} registros pendentes
        </small>
      </div>

      <div class="d-flex align-items-center gap-2 ms-3">
        <label for="tamanhoPaginaSelectFooter" class="mb-0" style="font-weight:600; font-size:0.9rem;">Itens /
          página</label>
        <select id="tamanhoPaginaSelectFooter" class="form-select form-select-sm" [(ngModel)]="tamanhoPagina"
          (ngModelChange)="onTamanhoPaginaChange($event)" style="width: 100px;">
          <option [value]="10">10</option>
          <option [value]="50">50</option>
          <option [value]="100">100</option>
        </select>
      </div>
    </div>

    <!-- Controles de navegação -->
    <nav aria-label="Navegação de páginas">
      <ul class="pagination pagination-sm mb-0">
        <!-- Primeira página -->
        <li class="page-item" [class.disabled]="paginaAtual === 1">
          <button class="page-link" (click)="irParaPagina(1)" [disabled]="paginaAtual === 1">
            <i class="bi bi-chevron-double-left"></i>
          </button>
        </li>

        <!-- Página anterior -->
        <li class="page-item" [class.disabled]="paginaAtual === 1">
          <button class="page-link" (click)="paginaAnterior()" [disabled]="paginaAtual === 1">
            <i class="bi bi-chevron-left"></i>
          </button>
        </li>

        <!-- Páginas numeradas -->
        <li class="page-item" *ngFor="let pagina of obterPaginas()" [class.active]="pagina === paginaAtual">
          <button class="page-link" (click)="irParaPagina(pagina)">
            {{pagina}}
          </button>
        </li>

        <!-- Próxima página -->
        <li class="page-item" [class.disabled]="paginaAtual === totalPaginas">
          <button class="page-link" (click)="proximaPagina()" [disabled]="paginaAtual === totalPaginas">
            <i class="bi bi-chevron-right"></i>
          </button>
        </li>

        <!-- Última página -->
        <li class="page-item" [class.disabled]="paginaAtual === totalPaginas">
          <button class="page-link" (click)="irParaPagina(totalPaginas)" [disabled]="paginaAtual === totalPaginas">
            <i class="bi bi-chevron-double-right"></i>
          </button>
        </li>
      </ul>
    </nav>
  </div>
</div>